var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9336 0H77.0664C94.7023 0 109 14.2977 109 31.9336V77.0664C109 94.7023 94.7023 109 77.0664 109H31.9336C14.2977 109 0 94.7023 0 77.0664V31.9336C0 14.2977 14.2977 0 31.9336 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0664 0H31.9336C14.2977 0 0 14.2977 0 31.9336V77.0664C0 94.7023 14.2977 109 31.9336 109H77.0664C94.7023 109 109 94.7023 109 77.0664V31.9336C109 14.2977 94.7023 0 77.0664 0ZM78.6503 84.111C78.6503 85.1179 75.6613 85.6204 69.6834 85.6204C63.7054 85.6204 60.7164 85.1179 60.7164 84.111V63.6905H48.2857V84.111C48.2857 85.1179 45.2967 85.6204 39.3188 85.6204C33.3408 85.6204 30.3518 85.1179 30.3518 84.111V25.2446C30.3518 24.0013 33.3408 23.3796 39.3188 23.3796C45.2967 23.3796 48.2857 24.0013 48.2857 25.2446V46.11H60.7164V25.4234C60.7164 24.5953 62.196 24.0034 65.1552 23.6479C66.6944 23.5308 68.2038 23.4691 69.6834 23.4691L74.2115 23.6479C77.1707 24.0034 78.6503 24.5953 78.6503 25.4234V84.111Z",
    fill: "url(#paint0_linear_56_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_10",
    x1: 9.35229,
    y1: 9.35229,
    x2: 99.6477,
    y2: 99.6477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FFFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BCEAF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.dc28cf1373da46b1627996974c9fa88d.svg";
export { ForwardRef as ReactComponent };